module.exports = __webpack_public_path__ + "img/download.fc1378ca.svg";